class SendCandidateInvitationReq{
    constructor() {
        this.candidateId = null;
        this.userId = null;
        this.templateId = null;
        this.candidateIds = null;
    }
}
export default SendCandidateInvitationReq;